import React from 'react'
import { Registry } from '@react-registry'
import { elementCategories } from '../../elementCategories'
import { H3Icon } from '../../../utils/Icon'
import { HeadingIcon } from '../../../utils/Icon'
import { cx, css } from '@emotion/css'
//@ts-ignore
import styles from '../style.module.css'
export * from './deserializer'
export const H3 = (props) => {
  const { className } = props.attrs || {}
  return (
    <div  {...props.attrs} className={styles['heading']}>
      <h3 {...props.attributes} className={cx(
        className,
        css`padding-top: var(--scrte-padding-top, 0px);`
      )}>
        {props.children}
      </h3>
    </div>
  )
}
Registry.register(
  {
    Component: H3,
    slashIconName: <H3Icon />,
    slashTitle: 'Heading 3',
    title: <h3 className={styles['h3']}>Heading 3</h3>,
    subtitle: 'Add heading level 3',
    category: elementCategories.TEXT_FORMAT,
    shortcut: { key: 'mod+alt+3' },
    isContentStackElement: true,
    inBasicToolbar: true,
    keywords: ['heading three', 'heading 3']
  },
  { id: 'h3', registry: 'v2.element' }
)
